<div class="description">
  <ng-content></ng-content>
</div>
